export const DetectOSAndBrowser = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    const platform = navigator.platform.toLowerCase();
    const userVendor = (navigator.vendor || "").toLowerCase();
    let OS = "Unknown OS";
    let Browser = "Unknown Browser";
    let SocialMediaBrowser: string | null = null;
  
    if (platform.includes("win")) {
      OS = "Windows";
    } else if (platform.includes("mac")) {
      OS = "MacOS";
    } else if (platform.includes("linux") && !userAgent.includes("android")) {
      OS = "Linux";
    } else if (userAgent.includes("android")) {
      OS = "Android";
    } else if (userAgent.includes("iphone") || userAgent.includes("ipad") || userAgent.includes("ipod")) {
      OS = "iOS";
    }
  
    // Detect Browser
    if (userAgent.includes("brave")) {
      Browser = "Brave";
    } else if (userAgent.includes("opr") || userAgent.includes("opera")) {
      Browser = "Opera";
    } else if (userAgent.includes("edg")) {
      Browser = "Edge";
    } else if (userAgent.includes("chrome") && !userAgent.includes("opr") && !userAgent.includes("edg")) {
      Browser = "Chrome";
    } else if (userAgent.includes("safari") && !userAgent.includes("chrome")) {
      Browser = "Safari";
    } else if (userAgent.includes("firefox")) {
      Browser = "Firefox";
    } else if (userAgent.includes("msie") || userAgent.includes("trident")) {
      Browser = "Internet Explorer";
    }

    const inAppPlatforms: Record<string, RegExp> = {
      facebook: /fban|fbav|fb_iab/i,
      instagram: /instagram/i,
      tiktok: /tiktok/i,
      twitter: /twitter/i,
      snapchat: /snapchat/i,
      line: /line/i,
      linkedin: /(linkedin|linkedinapp|liapp|li-app|li_app|linkedinapp\/|linkedin\/[0-9]|com\.linkedin|linkedinjavascript|li_ios|li_android)/i,     
      linkedin_2: /(linkedinapp|liapp|li-app|li_app|linkedin\/[0-9]|linkedin)/i,     
      gmail: /gmail/i,
      generic_email: /mailto|email/i, // generic email client
      whatsapp: /whatsapp/i,
      messenger: /messenger/i,
      youtube: /youtube/i,
      discord: /discord/i,
      telegram: /telegram/i,
      pinterest: /pinterest/i,
      reddit: /reddit/i,
      wechat: /micromessenger|wechat/i,
      chrome_webview_android: /chrome\/[0-9].*android/i,
      android_webview: /android.*wv|android.*webview/i,
      generic_inapp_webview: /inappbrowser|in-app/i, // generic catch-all
    };
  
    for (const [name, regex] of Object.entries(inAppPlatforms)) {
      if (regex.test(userAgent) || regex.test(userVendor)) 
      {
        SocialMediaBrowser = name;
        break;
      }
    }

    return { OS, Browser, SocialMediaBrowser };
    };